import React from 'react';
import styles from './Pagination.module.css';
import {Stack, StackItem} from "@fluentui/react";
import {Dropdown, IDropdownOption, IDropdownStyles} from "@fluentui/react/lib/Dropdown";
import ReactPaginate from 'react-paginate';
import {Icon} from "@fluentui/react/lib/Icon";
import EiopaFnPIcons from "../EiopaFnPIcons/EiopaFnPIcons";

interface PaginationProps {
    currentPage: number
    onPageChange: any
    itemsPerPage: number
    onChangeItemsPerPage: any
    totalItems: number
}

function Pagination(props: PaginationProps) {

    const options: IDropdownOption[] = [
        { key: 10, text: '10' },
        { key: 20, text: '20' },
        { key: 50, text: '50' }
    ];

    function onRenderArrow() {
        return (
            <Icon iconName={"CaretDownSolid8"} className={styles.CaretDownSolid8}/>
        )
    }

    const firstItem = props.totalItems === 0 ? 0 : ((props.currentPage - 1) * props.itemsPerPage) + 1;
    const lastItem = Math.min(firstItem + props.itemsPerPage - 1, props.totalItems);
    const totalPages = Math.ceil(props.totalItems / props.itemsPerPage);

    const itemsPerPageDropDownStyles: Partial<IDropdownStyles> = {
        title: { border: 'none', color: '#0078D4' },
        dropdown: {
            marginLeft: 20,
            selectors: {
                ':focus:after': { border: 'none' },
                ':active .ms-Dropdown-title': { border: 'none', color:'#0078D4' },
                ':focus .ms-Dropdown-title': { color:'#0078D4' },
                ':hover .ms-Dropdown-title': { color:'#0078D4' }
            }
        }
    }
    return (
        <Stack horizontal className={styles.paginationStack}>
            <StackItem>
                <div className={styles.itemPerPageWrapper}>
                    <span>Items per page</span>
                    <Dropdown
                        options={options}
                        selectedKey={props.itemsPerPage}
                        onChange={props.onChangeItemsPerPage}
                        onRenderCaretDown={onRenderArrow}
                        styles={itemsPerPageDropDownStyles}
                        data-testid = "items-per-page-dropdown"
                    />
                </div>
                <div>
                    Showing {firstItem} - {lastItem} of {props.totalItems} items
                </div>
            </StackItem>
            <StackItem>
                <Stack horizontal styles={{root: {alignItems:'center'}}}>
                    {props.currentPage > 1 ?
                        <StackItem className={styles.item} onClick={() => props.onPageChange(1)}>
                            <EiopaFnPIcons iconName={"firstPage"} iconColor={"#0078D4"}/>
                        </StackItem>
                    :
                        <StackItem className={styles.item + " " + styles.disabledPage}>
                            <EiopaFnPIcons iconName={"firstPage"} iconColor={"#A19F9D"}/>
                        </StackItem>
                    }
                    <StackItem>
                        <ReactPaginate
                            forcePage={props.currentPage - 1}
                            activeClassName={styles.item + ' ' +styles.active}
                            breakClassName={styles.item + ' ' +styles.breakMe}
                            breakLabel={'...'}
                            containerClassName={styles.pagination}
                            disabledClassName={styles.disabledPage}
                            marginPagesDisplayed={2}
                            nextClassName={styles.item + ' ' +styles.next}
                            nextLabel={<EiopaFnPIcons iconName={"nextPage"} iconColor={"#0078D4"}/>}
                            onPageChange={(selectedItem: { selected: number }) => props.onPageChange(selectedItem.selected + 1)}
                            pageCount={totalPages<1? 1 : totalPages}
                            pageClassName={styles.item + ' ' +styles.paginationPage}
                            pageRangeDisplayed={3}
                            previousClassName={styles.item + ' ' +styles.previous}
                            previousLabel={<EiopaFnPIcons iconName={"previousPage"} iconColor={"#0078D4"}/>}
                        />
                    </StackItem>
                    {props.currentPage < totalPages ?
                        <StackItem className={styles.item} onClick={() => props.onPageChange(totalPages)} data-testid="last-page-button" id="last-page-button">
                            <EiopaFnPIcons iconName={"lastPage"} iconColor={"#0078D4"}/>
                        </StackItem>
                        :
                        <StackItem className={styles.item + " " + styles.disabledPage} id="last-page-button">
                            <EiopaFnPIcons iconName={"lastPage"} iconColor={"#A19F9D"}/>
                        </StackItem>
                    }
                </Stack>
            </StackItem>
        </Stack>
    )
}

export default Pagination;
